class enabledStudentsServices {
    constructor($resource,SERVICE_URL_CONSTANT) {
		const services = $resource(SERVICE_URL_CONSTANT.adminPanel +'/enabled-student/:route',{},{
			getEnabledStudents:{
				method:'GET',
				params : {}
			},
			saveEnabledStudents:{
				method:'POST',
				params : {}
			},
		});

		const servicesPeriod = $resource(SERVICE_URL_CONSTANT.adminPanel +'/period/:route',{},{
			getPeriod:{
				method:'GET',
				params : {}
			},
		});

		return {
			services : services,
			servicesPeriod: servicesPeriod
		};
	}
}

enabledStudentsServices.$inject=['$resource','SERVICE_URL_CONSTANT']

export default  angular.module('services.enabledStudentsServices', [])
.service('enabledStudentsServices', enabledStudentsServices)
.name;



// WEBPACK FOOTER //
// ./src/app/admin-panel/enabledStudents/enabledStudentsServices.js